<template>
  <div class="inline-block-container">
    <span @click="openModalAction" class="button-link">新規登録</span>
    <ModalBackground v-if="isActive"/>
    <div v-if="isActive" class="modal-container" @click.self="closeModalAction">
      <div class="inner">
        <div class="close-button-container" @click="closeModalAction">
          <CloseButton/>
        </div>
        <FormHelper class="form-container" @callback="callback" :formSettings="formSettings"/>
      </div>
    </div>
    <div v-if="$isDebug() && debugVerifyToken" class="debug-option-container">
      <router-link :to="{name: 'Register', params:{token: debugVerifyToken}}" class="link">[DEBUG]メール認証</router-link>
    </div>
  </div>
</template>

<script>

import ModalBackground from '@/components/common/ModalBackground';
import FormHelper from '@/components/common/FormHelper';
import CloseButton from '@/components/user/CloseButton';

export default {
  components: {
    ModalBackground,
    FormHelper,
    CloseButton
  },
  data () {
    return {
      formSettings: { //フォームの設定を記載
        store: 'user',
        dispatch: 'entry',
        header: 'サインアップ',
        forms: {
          email: {
            label: 'メールアドレス',
            type: 'text',
            value: null,
            require: true,
            placeholder: this.$placeholderEmail,
            default: '',
            validate: [],
            option: {
              size: 300,
            }
          }
        },
        useSessionId: true,
        submit: {
          label: 'サインアップ',
          color: 'b'
        },
        info: [ // フォーム下部の補足説明
          '本登録の案内メールがすぐに送信されます',
          'メールが届かない場合は念のため迷惑メールフォルダをご確認ください'
        ]
      },
      option: {
        is1Button: true,
        buttonLabel: '閉じる',
        callback: 'OK1',
        callbackO: 'close',
        messages: ['入力されたメールアドレスにメールを送信しました', 'メールの内容をご確認ください']
      },
      existOption: {
        is1Button: true,
        buttonLabel: '閉じる',
        callback: 'OK1',
        callbackO: 'close',
        messages: ['すでにご登録されているメールアドレスです']
      },
      isActive: false,
      debugVerifyToken: null
    };
  },
  methods: {
    openModalAction: function () {
      console.log('openModalAction');
      this.isActive = true;

      scrollTo(0, 0);
    },
    closeModalAction: function () {
      console.log('closeModalAction');
      this.isActive = false;
    },
    callback: function (dispatcher, value) {
      console.log('callback', dispatcher, value);

      this.isActive = false;

      if (dispatcher === 'FormHelperNotice') {

        let getter = this.formSettings.store + '/reasonCode';
        let reasonCode = this.$store.getters[getter];

        if (reasonCode === 'DUPLICATE_EMAIL_ENTRY') {

          // すでに登録ずみのメッセージ
          this.$store.dispatch('message/open', this.existOption).then();

        } else {

          this.$store.dispatch('errorInfo/setErrorStore', this.formSettings.store).then();
          this.$router.push({name: 'UserSystemError'});
        }

      } else {

        // 完了メッセージ
        this.$store.dispatch('message/open', this.option).then();

        if (!this.$isDebug()) {
          return;
        }

        // -- デバッグリンク

        let getter = this.formSettings.store + '/response';

        let response = this.$store.getters[getter];
        console.log(response.token);

        this.debugVerifyToken = response.token;

      }

    }
  }
};

</script>

<style lang="scss" scoped>

  @import '../../assets/styles/_variable.scss';

  .button-link {
    display: inline-block;
    width: 180px;
    height: 50px;
    line-height: 50px;
    background: #fff;
    border: 1px solid $keyColor;
    border-radius: 25px;
    cursor: pointer;
    font-weight: bold;
    color: $keyColor;
    margin-bottom: 1px;

    &:hover {
      opacity: .8;
    }

    &:active {
      background: $subColor1;
    }

  }

</style>
